import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { ObligationsListPage } from './ObligationsListPage';
import { ObligationsEditPageWrapper } from './ObligationsEditPageWrapper';

export function ObligationsPage({ obligation, isExpanded }) {
  return (
    <Routes obligation={obligation}>
      <Route
        path="/"
        exact
        element={<ObligationsListPage isExpanded={isExpanded} />}
      />
      <Route
        path="add"
        element={<ObligationsEditPageWrapper isExpanded={isExpanded} />}
      />
      <Route
        path="edit/:id"
        element={<ObligationsEditPageWrapper isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

ObligationsPage.propTypes = {
  obligation: propTypes.object.isRequired,
  isExpanded: propTypes.bool.isRequired,
};
